import dataApi from '../'

export default {

  /**
  * Get the build properties
  */
  getBuildProperties () {
    return dataApi.request({
      method: 'get',
      url: 'ui/utility/version',
      authorization: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/utility.js